import { createContext, useState } from "react";
import clienteAxios from "../config/clienteAxios";
import toast from "react-hot-toast";

const FooterContext = createContext();

const FooterProvider = ({ children }) => {
  const [footerCats, setFooterCats] = useState([]);

  const getAllFooterCats = async () => {
    try {
      const { data } = await clienteAxios.get("/footerCategory");
      setFooterCats(data?.allFooterCat);
    } catch (error) {
      toast.error('Error al obtener datos del footer')
    }
  };

  const createFooterCat = async (category) => {
    try {
      const { data } = await clienteAxios.post("/footerCategory", category);
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  const updateFooterCat = async (category) => {
    try {
      const { data } = await clienteAxios.put("/footerCategory", category);
      return data;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <FooterContext.Provider value={{ footerCats, createFooterCat, updateFooterCat, getAllFooterCats }}>
      {children}
    </FooterContext.Provider>
  );
};

export { FooterProvider };

export default FooterContext;
